import clsx from 'clsx';
import Link from 'next/link';
import DallasText from '@ui/Dallas/Text/DallasText';
import DallasSvgIcon from '@ui/Dallas/Icons/DallasSvgIcon';
import styles from './NavItem.module.scss';
import { HTMLAttributeAnchorTarget } from 'react';

export interface Props {
  className?: string;
  icon?: React.ReactElement<typeof DallasSvgIcon>;
  href: string;
  label: string;
  active?: boolean;
  target?: HTMLAttributeAnchorTarget;
  prefetch?: boolean;
  withBrandBadge?: boolean;
  onClick?: () => Promise<void> | void;
}

export default function NavLink({
  className,
  href,
  icon,
  label,
  target,
  active = false,
  prefetch = false,
  withBrandBadge = false,
  onClick,
}: Props) {
  return (
    <Link
      className={clsx(
        className,
        styles.root,
        active && styles.active,
        withBrandBadge && styles.withBrandBadge,
      )}
      target={target}
      href={href}
      prefetch={prefetch}
      onClick={onClick}
    >
      {icon ?? <div className={styles.iconPlaceholder}></div>}
      <DallasText
        className={styles.label}
        variant={icon ? 'body' : 'captionL'}
        align="start"
      >
        {label}
      </DallasText>
    </Link>
  );
}
